"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SchoolSample = void 0;
var Sample_1 = require("./Sample");
var SchoolSample = /** @class */ (function (_super) {
    __extends(SchoolSample, _super);
    function SchoolSample() {
        return _super.call(this) || this;
    }
    return SchoolSample;
}(Sample_1.BaseSchoolSample));
exports.SchoolSample = SchoolSample;
//# sourceMappingURL=SchoolSample.js.map